import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import * as Sentry from '@sentry/react'
import './index.css'
import './lib/i18n'
import App from './App'
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    // Capture 10% of transactions for performance monitoring
    tracesSampleRate: 0.1,
    // Do not send errors in development (VITE_SENTRY_DSN is unset in dev by convention)
    enabled: import.meta.env.PROD,
  })
}

const root = createRoot(document.getElementById('root')!)

if (!PUBLISHABLE_KEY) {
  // No Clerk key configured — render a config error (developer-facing only;
  // production deployments always set VITE_CLERK_PUBLISHABLE_KEY)
  root.render(
    <StrictMode>
      <div style={{ fontFamily: 'sans-serif', padding: '2rem', color: '#333' }}>
        <strong>Clausule — Missing configuration</strong>
        <p>Set <code>VITE_CLERK_PUBLISHABLE_KEY</code> in your <code>.env.local</code> to run the app.</p>
      </div>
    </StrictMode>
  )
} else {
  root.render(
    <StrictMode>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
        <App />
      </ClerkProvider>
    </StrictMode>
  )
}
